import React from "react";
import AppDialog from "components/AppDialog";
import Input from "components/base/Input";
import { FORM_INPUT_CLASSNAME } from "components/base/FormLabel";
import { Button } from "components/ui/button";
import { validateSearchCriteriaTitle } from "utils/validation";

function SaveSearchDialog({
  open,
  setOpen,
  inputs,
  setInputs,
  errors,
  setErrors,
  onSave,
}) {
  const handleValidation = (e) => {
    e.preventDefault();
    validateSearchCriteriaTitle({
      data: inputs,
      onSuccess: onSave,
      onError: setErrors,
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <button
        type="button"
        className="filter-sidebar-btn flex-1 font-normal"
        onClick={() => setOpen(true)}
      >
        Save Search
      </button>

      <AppDialog
        open={open}
        onOpenChange={setOpen}
        onClose={handleClose}
        header="Save Current Search"
        className="w-full max-w-md overflow-hidden rounded-lg"
        contentClassName="px-6 pb-6 pt-4"
      >
        <form className="flex flex-col" onSubmit={handleValidation}>
          <Input
            inputClassName={FORM_INPUT_CLASSNAME}
            value={inputs.criteriaTitle}
            placeholder="Name"
            errorMessage={errors.criteriaTitle}
            onChange={({ value }) =>
              setInputs((prev) => ({ ...prev, criteriaTitle: value }))
            }
          />

          <div className="flex justify-end">
            <Button type="submit">Save Search</Button>
          </div>
        </form>
      </AppDialog>
    </>
  );
}

export default SaveSearchDialog;
